<template>
  <basic-container>
     <el-tabs v-model="activeName" type="card" @tab-click="tableData=[];searchAct()">
      <el-tab-pane label="线上数据" name="1"></el-tab-pane>
      <el-tab-pane label="本地数据" name="0"></el-tab-pane>
    </el-tabs>
    <!-- serch -->
    <div class="search_group">
        <date-range-destructor
          :start.sync="startUpdateTime"
          :end.sync="endUpdateTime"
          start-placeholder="创建开始时间"
          end-placeholder="创建结束时间"
          value-format="yyyy-MM-dd"
          type="daterange"
          format = "yyyy-MM-dd">
        </date-range-destructor>

      <el-select @change="searchAct" v-model="formStatus" size="small" clearable placeholder="上架状态">
        <el-option label="上架" :value="1"></el-option>
        <el-option label="下架" :value="2"></el-option>
      </el-select>

      <el-select @change="searchAct" v-model="formCheckStatus" size="small" clearable placeholder="审核状态" v-if="activeName=='0'">
        <el-option label="待审批" :value="0"></el-option>
        <el-option label="待审核" :value="1"></el-option>
        <el-option label="审核通过" :value="2"></el-option>
        <el-option label="审核不通过" :value="3"></el-option>
        <el-option label="审批不通过" :value="4"></el-option>
      </el-select>
      <el-input :maxlength="30" v-model="formName" size="small" placeholder="视频标题"></el-input>
        <el-select size="small"
          v-model="selectValue"
          filterable
          allow-create
          clearable
          default-first-option
          placeholder="输入标签对视频分组">
          <el-option
            v-for="item in selectOptions"
            :key="item.deptName"
            :label="item.groupName"
            :value="item.groupName">
            <span style="float: left">{{ item.groupName }}</span>
            <span style="float: right; color: #8492a6; font-size: 13px">{{ item.deptName }}</span>
          </el-option>
        </el-select>
       <el-select size="small"
        v-model="selectedId"
              clearable
              placeholder="所属企业"
              @clear="handleClear"
              ref="selectUpResId"
            >
        <el-option hidden key="selectedId" :value="selectedId" :label="selectetName"></el-option>
        <el-tree
          :data="deptTreeList"
          :props="defaultProps"
          :expand-on-click-node="false"
          :check-on-click-node="true"
          @node-click="handleNodeClick"
        >
        </el-tree>
       </el-select>
      <el-button @click="searchAct" icon="el-icon-search" size="small" type="primary">搜索</el-button>
      <el-button @click="handleExport" icon="el-icon-download" size="small" type="warning">导出</el-button>
    </div>
    <!-- taba -->
    <el-table :max-height="tableHeight"
      :key="activeName" v-loading="listLoading" element-loading-text="加载中" border :data="tableData">
      <el-table-column prop="id" label="ID" width="200"></el-table-column>
      <el-table-column prop="name" label="视频标题" width="350" align="left"></el-table-column>
      <el-table-column label="封面" width="200" align="center">
        <template slot-scope="scope">
          <img :src="scope.row.coverImageUrl" style="height: 50px"/>
        </template>
      </el-table-column>
      <el-table-column  label="视频" width="200" align="center">
        <template slot-scope="scope">
           <img :src="scope.row.coverImageUrl" @click="openVideo(scope.row)" style="cursor:pointer" height="50px" />
        </template>
      </el-table-column>
      <el-table-column prop="groupName" label="分组标签" width="100" align="center" ></el-table-column>
      <el-table-column prop="descInfo" label="描述" align="left" width="200"></el-table-column>
      <el-table-column prop="playTimes" label="累计观看" width="100" align="center"></el-table-column>
      <el-table-column prop="favorTimes" label="喜欢" width="50"></el-table-column>
      <el-table-column prop="deptName" label="所属企业" width="150" align="center"></el-table-column>
      <el-table-column prop="videoStatus" label="转码状态" width="100">
        <template slot-scope="scope">
          {{scope.row.videoStatus==1?'上传成功':scope.row.videoStatus==2?'转码中':scope.row.videoStatus==3?'转码成功':scope.row.videoStatus==4?'转码失败':''}}
        </template>     
      </el-table-column>
      <el-table-column prop="status" label="上架状态" width="100" align="center">
        <template slot-scope="scope">
          {{scope.row.status==1?'上架':scope.row.status==2?'下架':''}}
        </template>
      </el-table-column>                           
      <el-table-column prop="reviewStatus" label="审核状态" width="100" align="center">
        <template slot-scope="scope">
          <!-- {{scope.row.reviewStatus==2?'审核通过':scope.row.reviewStatus==3?'审核拒绝':scope.row.reviewStatus==1?'待审核':''}} -->
          {{videoIsinWhatstatus(scope.row)}}
        </template>    
      </el-table-column>
      <el-table-column prop="updateUserName" label="更新人" width="100" align="center"></el-table-column>
      <el-table-column prop="updateTime" label="更新时间" align="center"></el-table-column>
      <el-table-column v-if="activeName=='0'" fixed="right" width="300" label="操作" align="center">
        <template slot-scope="scope">
          <el-button @click="openCheck(scope.row)" v-if="scope.row.contentStatus==1&&scope.row.reviewStatus==1" icon="el-icon-info" size="mini" type="text" v-auth="'contentmanage_content_approval'">审批</el-button>
          <el-button @click="openCheck(scope.row)" v-if="scope.row.contentStatus==2&&scope.row.reviewStatus==1" icon="el-icon-info" size="mini" type="text" v-auth="'contentmanage_content_examine'">审核</el-button>
          <el-button @click="openLog(scope.row)" icon="el-icon-view" size="mini" type="text" v-auth="'contentmanage_content_viewlog'">查看日志</el-button>
          <el-button v-if="activeName=='0'&&scope.row.contentStatus!=3&&scope.row.contentStatus!=1" @click="openEdit(scope.row)" icon="el-icon-edit" size="small" type="text" v-auth="'contentmanage_content_update'">修改</el-button>
          <el-button v-if="activeName=='0'" @click="delDiscount(scope.row)" v-auth="'contentmanage_content_del'" icon="el-icon-delete" size="small" type="text">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <div class="table_pagination">
      <el-pagination class="app-pagination" background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="pageNo" :page-sizes="pageSizeArr" :page-size="pageSize" :layout="paginationLayout" :total="totalEl">
      </el-pagination>
    </div>

    <!-- 审批dialog -->
    <el-dialog :title="checkItem.contentStatus==1?'审批':'审核'" :visible.sync="showCheck" append-to-body width="40%" ref="ruleForm">
      <el-form :model="checkItem" size="mini" label-width="110px">
        <el-form-item label="视频ID">{{checkItem.id}}</el-form-item>
        <el-form-item label="所属企业">{{checkItem.deptName}}</el-form-item>
        <el-form-item label="视频标题">{{checkItem.name}}</el-form-item>
        <el-form-item label="视频资源" v-if="checkItem.contentStatus==1">
          <el-table :data="checkItem.playInfo">
            <el-table-column label="文件类型" width="150">
              <template slot-scope="scope">{{scope.row.definition=='od'||scope.row.definition=='OD'?'原始文件':'转码文件'}}</template>
            </el-table-column>
            <el-table-column property="format" label="格式" width="200"></el-table-column>
            <el-table-column property="definition" label="分辨率"></el-table-column>
            <el-table-column property="bitrate" label="码率"></el-table-column>
            <el-table-column property="width" label="地址"></el-table-column>
            <el-table-column property="size" label="大小"></el-table-column>
            <el-table-column v-if="activeName=='0'" fixed="right" width="250" label="操作">
              <template slot-scope="scope">
                <el-button @click="openVideo(scope.row)" size="small" type="text">预览</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label="视频资源" v-if="checkItem.contentStatus==2">
          <el-image :src="checkItem.coverImageUrl" :fit="fit">
            <div slot="placeholder" class="image-slot" style="width:120px;height:70px">
              加载中<span class="dot">...</span>
            </div>
          </el-image>
          <el-button  class="viewbigImg" @click="openVideo(checkItem)">预览</el-button>
        </el-form-item>
        <el-form-item label="视频封面">
          <el-image :src="checkItem.coverImageUrl" :fit="fit">
            <div slot="placeholder" class="image-slot" style="width:120px;height:70px">
              加载中<span class="dot">...</span>
            </div>
          </el-image>
          <el-button  class="viewbigImg" @click="showViewbigImg">查看大图</el-button>
          <el-dialog title="" :visible.sync="viewbigImg" :modal="false" :modal-append-to-body="false">
            <img :src="checkItem.coverImageUrl" v-show="viewbigImg" width="100%" height="100%">
          </el-dialog>
        </el-form-item>
        <el-form-item label="分组标签">{{checkItem.groupName}}</el-form-item>
        <el-form-item label="描述">{{checkItem.descInfo}}</el-form-item>
        <el-form-item label="视频分类" required="true" v-if="checkItem.contentStatus==1">
          <el-checkbox-group v-model="checkItem.catalogs" max='3'>
            <el-checkbox-button v-for="item in catalogList" :label="item.id" :key="item.id" >{{item.catalogName}}</el-checkbox-button>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="视频分类" v-if="checkItem.contentStatus==2" max='3'>
          <el-checkbox-group v-model="checkItem.catalogs" disabled="true">
            <el-checkbox-button v-for="item in checkItem.catalogName" :key="item.index" >{{item}}</el-checkbox-button>
          </el-checkbox-group>
        </el-form-item>
        <!-- 审核回显 -->
        <el-form-item v-if="checkItem.contentStatus==2&&checkItem.reviewStatus==1">
        
          <div v-for="(item, index) in checkItem.schemaData" :key="index" class="checkitemcheck" > 
            <el-form-item label="跳转应用">
              <el-select v-model="item.appId" placeholder="请选择跳转应用" disabled>
                <el-option
                  v-for="item in appInfoData"
                  :key="item.id"
                  :label="item.appName"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
              <el-form-item
                  label="AndroidScheme"
              >
                  <el-input v-model="item.androidSchema" disabled></el-input>
              </el-form-item>
              <el-form-item
                  label="iOSScheme">
                  <el-input v-model="item.iosSchema" disabled></el-input>
              </el-form-item>
              <el-form-item>
              </el-form-item>
          </div>
        </el-form-item>
        <el-form-item 
          label="审批意见"
          required="true" v-if="checkItem.contentStatus==1">
          <el-radio-group v-model="checkItem.reviewStatus">
            <el-radio :label='2' v-model="checkItem.reviewStatus">审批通过</el-radio>
            <el-radio :label='3' v-model="checkItem.reviewStatus">审批不通过</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="审批后展示" v-if="checkItem.reviewStatus != '3'&&checkItem.contentStatus==1" required="true" >
          <el-radio-group v-model="checkItem.status">
            <el-radio :label="1" v-model="checkItem.status">上架</el-radio>
            <el-radio :label="2" v-model="checkItem.status">下架</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="上架状态" v-if="checkItem.reviewStatus =='1'&&checkItem.contentStatus==2">{{checkItem.status==1?'上架':'下架'}}</el-form-item>
        <el-form-item label="理由" v-if="checkItem.reviewStatus == '3'&&checkItem.contentStatus==1" required="true">
          <el-input type="textarea" :rows="3" :maxlength="150" resize="none" v-model="checkItem.checkMark" placeholder="请输入不通过的理由"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="submitcheck(checkItem, 2)" size="small" type="primary" icon="el-icon-circle-check" v-if="checkItem.contentStatus==2" v-auth="'contentmanage_content_examine'">通过审核</el-button>
        <el-button @click="submitcheck(checkItem, 3)" size="small" type="danger" icon="el-icon-circle-close" v-if="checkItem.contentStatus==2" v-auth="'contentmanage_content_examine'">拒绝审核</el-button>
        <el-button @click="changeCheck(checkItem)" size="small" type="primary" icon="el-icon-circle-check" v-else v-auth="'contentmanage_content_approval'">审批完成</el-button>
        <el-button @click="showCheck=false" size="small" icon="el-icon-circle-close">取消</el-button>
      </div>
    </el-dialog>

    <!-- logdialog -->
    <el-dialog title="操作日志" :visible.sync="showLog" append-to-body width="40%">
      <el-table :max-height="400" border :data="logData">
        <el-table-column prop="applyUserName" label="申请人"></el-table-column>
        <el-table-column prop="applyTime" label="申请时间" width="180"></el-table-column>
        <el-table-column prop="operationType" label="操作类型"></el-table-column>
        <el-table-column prop="reviewUserName" label="审核人"></el-table-column>
        <el-table-column prop="reviewContent" show-overflow-tooltip label="审核内容"></el-table-column>
        <el-table-column prop="reviewTime" label="审核时间" width="180"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showLog=false" size="small" type="primary" icon="el-icon-circle-check">关闭</el-button>
      </div>
    </el-dialog>
    <!-- 修改弹窗 -->
    <el-dialog title="修改视频内容" :visible.sync="showEdit" append-to-body width="40%" :before-close="handleAddOrEditClose"  :key="key" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form :model="checkItem" size="mini" label-width="110px">
        <el-form-item label="视频ID">{{checkItem.id}}</el-form-item>
        <el-form-item label="所属企业">{{checkItem.deptName}}</el-form-item>
        <el-form-item label="视频标题" prop="name">
          <el-input type="text" v-model="checkItem.name" size="small"></el-input> 
        </el-form-item>
        <el-form-item label="视频资源">
          <el-table :data="checkItem.playInfo">
            <el-table-column property="" label="文件类型" width="150">
              <template slot-scope="scope">{{scope.row.definition=='od'||scope.row.definition=='OD'?'原始文件':'转码文件'}}</template>
            </el-table-column>
            <el-table-column property="format" label="格式" width="200"></el-table-column>
            <el-table-column property="definition" label="分辨率"></el-table-column>
            <el-table-column property="bitrate" label="码率"></el-table-column>
            <el-table-column property="width" label="地址"></el-table-column>
            <el-table-column property="size" label="大小"></el-table-column>
            <el-table-column v-if="activeName=='0'" fixed="right" width="250" label="操作">
              <template slot-scope="scope">
              <el-button @click="openVideo(scope.row)" icon="el-icon-delete" size="small" type="text">预览</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>

          <el-form-item>
            <el-upload
              action="#"
              :on-change="handleChangeVideo"
              :file-list="fileList"
              :on-preview="handlePreview"
              :auto-upload="false">
              <el-button size="small" type="primary">重新上传</el-button>
              <div slot="tip" class="el-upload__tip">只能上传.mp4视频文件，且不超过1G</div>
            </el-upload>
            <el-progress :percentage="authProgress" color="#409eff" v-if="showProgress"></el-progress>
          </el-form-item>

          <el-form-item label="视频封面">
            <el-upload
              action="#"
              list-type="picture-card"
              :on-preview="handleImgsPreview"
              :auto-upload="false"
              accept=".jpeg,.jpg,.png"
              :file-list="fileImgesList"
              :on-exceed="onexceedVideo"
              :on-change="handleChangeImgs"
              :on-remove="handleRemove">
              <el-button size="small" type="primary">重新上传</el-button>
            </el-upload>
              只能上传jpg、jpeg和png，大小不超过500K
            <el-dialog :visible.sync="dialogImageVisible" append-to-body>
              <img width="100%" :src="dialogImageUrl" alt="">
            </el-dialog>
          </el-form-item>          

          <el-form-item label="标签分组">
            <el-select
              v-model="selectValue"
              filterable
              allow-create
              default-first-option
              placeholder="输入标签对视频分组">
              <el-option
                v-for="item in selectOptions"
                :key="item.deptName"
                :label="item.groupName"
                :value="item.groupName">
                <span style="float: left">{{ item.groupName }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.deptName }}</span>
              </el-option>
            </el-select>
          </el-form-item>
        <el-form-item label="描述">
          <el-input type="textarea" :maxlength="60" resize="none" v-model="checkItem.descInfo" placeholder="请输入视频描述,最多60个汉字"></el-input>
        </el-form-item>

        <el-form-item label="视频分类">
          <el-checkbox-group v-model="checkItem.catalogs" max='3'>
            <el-checkbox-button v-for="item in catalogList" :label="item.id" :key="item.id">{{item.catalogName}}</el-checkbox-button>
          </el-checkbox-group>
        </el-form-item>
        <!-- 动态添加 -->
        <el-form-item label="选择跳转应用">
          <el-select clearable v-model="form.appId" @change="selectName(form.appId)" placeholder="请选择跳转应用">
            <el-option
              v-for="item in appInfoData"
              :key="item.id"
              :label="item.appName"
              :value="item.id">
            </el-option>
          </el-select>
          <el-button @click="addItem" size="small" type="primary" icon="el-icon-circle-check" style="margin-left:20px">增加</el-button>
        </el-form-item>
        <el-form-item label="Androidscheme">
          <el-input type="text" v-model="form.androidSchema" size="small"></el-input> 
        </el-form-item>
        <el-form-item label="iOSscheme">
          <el-input type="text" v-model="form.iosSchema" size="small"></el-input> 
        </el-form-item>

        <div v-for="(item, index) in form.dynamicItem" :key="item.id">
          <el-form-item label="选择跳转应用">
            <el-select clearable v-model="item.appId" @change="moreSelectName(item.appId,index,item)" placeholder="请选择跳转应用">
              <el-option
                v-for="item in appInfoData"
                :key="item.id"
                :label="item.appName"
                :value="item.id">
              </el-option>
            </el-select>
            <el-button @click="deleteItem(item, index)" size="small" type="warning" icon="el-icon-circle-check" style="margin-left:20px">删除</el-button>
          </el-form-item>
            <el-form-item
                label="Androidscheme"
            >
                <el-input v-model="item.androidSchema"></el-input>
            </el-form-item>
            <el-form-item
                label="iOSscheme">
                <el-input v-model="item.iosSchema"></el-input>
            </el-form-item>
            <el-form-item>
            </el-form-item>
        </div>
        <el-form-item label="状态">
          <el-radio-group v-model="checkItem.status">
            <el-radio :label="1" v-model="status">上架</el-radio>
            <el-radio :label="2" v-model="status">下架</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="submitEdit(checkItem)" v-auth="'contentmanage_content_update'" size="small" type="primary" icon="el-icon-circle-check">保存修改</el-button>
        <el-button @click="showEdit=false" size="small" icon="el-icon-circle-close">取消</el-button>
      </div>
    </el-dialog>

    <!-- 视频弹窗 -->
    <el-dialog title="视频播放"  append-to-body width="50%"
      :visible.sync="dialogShowPlayVideo" 
      :before-close="handleVideoClose">
      <video :src="playURL" id="vide" controls="controls" width="100%">
         your browser does not support the video tag
      </video>
    </el-dialog>
  </basic-container>
</template>

<script>
import { contentList, getclassifiedList,submitExamine, submitEditData, getUploadVideo, findGroups , removeVideo, getAppInfoData } from '@/api/contentManage/index'
// import { contentList, getclassifiedList,submitExamine, getUploadVideo, findGroups , removeVideo, getAppInfoData } from '@/api/contentManage/index'
import {putFile} from "@/api/app"
import { getApproveLogs } from '@/api/logs';
import {mapState} from "vuex"
import { debounce, deepCopy } from '@/util/common'
import pagination from '@/util/mixins/pagination'
import axios from 'axios'
import * as moment from 'moment'
import ListMixins from '@/util/mixins/listPage'
import {getDeptTree} from "@/api/system/dept"
import { downloadFile } from '@/util/util'

export default {
  mixins: [pagination,ListMixins],
  data () {
    return {
      selectedId:'',
      deptTreeList: [],
      defaultProps: {
        children: 'children',
        label: 'title'
      },
      formId: '',
      formStatus: '',
      formName: '',
      startUpdateTime: '',
      endUpdateTime:'',
      formCheckStatus: '',
      activeName: '1', // 选择tab
      checkStatus: '', // 审核状态
      checkItem: {
        vid: '',
        schemaData: [],
      }, // 查看项
      checkMark: '', // 审核意见
      showCheck: false, // 审核弹窗
      logData: [], // 日志列表
      showLog: false, // 操作日志弹窗
      requestUrlType:'',
      showEdit: false, // 新增/修改弹窗
      catalogList:[], //视频分类标签
      viewbigImg: false,
      // 视频上传定义
      fileList: [], //显示列表
      fileImgesList: [],
      files:{ // 视频文件
        videoFile:''
      },
      authProgress:0, //上传百分比
      showProgress:false,  //上传进度条
      dialogShowPlayVideo: false, // 视频弹窗
      // 分组标签数据定义
      selectValue:[],
      selectOptions:[],
      appInfoData:[],
      form:{
        appId:'',
        androidSchema:'',
        iosSchema:'',
        dynamicItem: []
      },
      key:0
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.user.userInfo
    }),
  },
  created () {
    this.endUpdateTime = moment(new Date()).format('YYYY-MM-DD 23:59:59').toString()
    this.startUpdateTime = moment(new Date()).subtract(1,'months').format('YYYY-MM-DD 00:00:00').toString()
    this.getList()
  },
  mounted () {
    this.getList()
    this.getclassified()
    this.getGroupsList()
    this.getAppInfo()
    getDeptTree(this.userInfo.tenant_id).then(res => {
      this.deptTreeList = res.data.data
    });
  },
  methods: {
    videoIsinWhatstatus(row){
      if (row.reviewStatus==1&&row.contentStatus==1) {
        return '待审批'
      }
      if (row.reviewStatus==2&&row.contentStatus==2) {
        return '审核通过'
      }
      if (row.contentStatus==3) {
        return '审批不通过'
      }
      if (row.reviewStatus==1&&row.contentStatus==2) {
        return '待审核'
      }
      if (row.reviewStatus==3) {
        return '审核不通过'
      }
    },
    getAppInfo(){
      let postData= {
        appName: '',
        status: ''
      }
      getAppInfoData(postData).then(res =>{
        if (res.data.code === 200) {
          this.appInfoData = res.data.data || []
          console.log('res.data---------',res.data.data)
        } else {
            this.$message.error(res.data.msg)
          } 
      //  console.log('res---------',res)
      })
    },
    handleNodeClick(data) {
      // 这里主要配置树形组件点击节点后，设置选择器的值；自己配置的数据，仅供参考
      this.selectetName = data.title
      this.selectedId = data.id
      // 选择器执行完成后，使其失去焦点隐藏下拉框的效果
      this.$refs.selectUpResId.blur()
    },
    handleClear() {
      // 将选择器的值置空
      this.selectetName = ''
      this.selectedId = ''
    },
    selectName (e) {
      if (e==''||e==undefined){
        this.form.androidSchema = ''
        this.form.iosSchema = ''
      } else {
        let obj = {}
        obj = this.appInfoData.find((item)=>{
            return item.id == e
        })
        this.form.androidSchema = obj.androidSchema
        this.form.iosSchema = obj.iosSchema
      }
    },
    moreSelectName (e,index,selectOption) {
      if (e==''||e==undefined) {
        selectOption.androidSchema = ''
        selectOption.iosSchema = ''
      } else {
        let obj = {}
        obj = this.appInfoData.find((item)=>{
            return item.id == e
        })
        console.log(obj)
        selectOption.androidSchema = obj.androidSchema
        selectOption.iosSchema =obj.iosSchema
      }
    },
    addItem () {
      console.log('this.checkItem.coverImageUrl',this.checkItem.coverImageUrl)
      if (this.form.dynamicItem && this.form.dynamicItem.length > 8) {
        this.$message.error('最多只能添加9组应用')
        return false
      }
      this.form.dynamicItem.push({
        androidSchema: '',
        iosSchema: '',
        appId:''
      })
      this.key += 1
      this.fileImgesList = [{name:"",url: this.checkItem.coverImageUrl}]
      // console.log('this.checkItem.coverImageUrl',this.checkItem.coverImageUrl)
      // this.checkItem.coverImageUrl = this.checkItem.coverImageUrl
    },
    deleteItem (item, index) {
      console.log(this.form.dynamicItem)
      this.form.dynamicItem.splice(index, 1)
      this.key += 1
    },
    getGroupsList () {
      findGroups(null).then(res =>{
        if (res.data.code === 200) {
          this.selectOptions = res.data.data
              console.log(this.selectOptions)
        } else {
            this.$message.error(res.data.msg)
          }
      })
    },
    // 视频弹窗
    openVideo(row) {
      console.log(row)
      console.log("[click row data]",  row.playInfo)
      if(row.playInfo){
        let list = row.playInfo;
        let urls = list.filter(item => (item.format == 'mp4' || item.format == 'MP4') )
        this.playURL = urls[0].playURL
        this.dialogShowPlayVideo = true
      } else {
        if ( row.format == 'mp4' || row.format == 'MP4' ){
          this.playURL = row.playURL
          this.dialogShowPlayVideo = true
        }else {
          this.$message({
            message: '暂不支持除MP4格式外的视频预览',
            type: 'warning'
          })
          return false
        }
      }

    },
    //关闭弹窗视频
    handleVideoClose(done){
      //视频暂停
      console.log("[handleVideoClose] 监听关闭")
      let vide = document.getElementById("vide");
      vide.pause();
      done();
    },
    //关闭编辑或者新增弹窗置空数组
    handleAddOrEditClose(){
    console.log("[handleAddOrEditClose] 取消弹窗")

    this.showEdit=false
    this.viewbigImg = false
    this.key += 1
      this.fileList = []
      this.fileImgesList =[]
      this.form={
        appId:'',
        androidSchema:'',
        iosSchema:''
      }
    },
    // 过滤标签
    formateList (url) {
      let newArr = []
      url.map((item)=>{
        if(item.children){
          newArr = newArr.concat(item.children)
        }
      })
      return newArr
    },
    //视频过滤
    videmUrl (url,name) {
      return name+".mp4"
    },
    showViewbigImg () {
      this.viewbigImg = true
    },
    closeViewbigImg () {
      this.viewbigImg = false
    },
    // 打开审核或审批
    openCheck (item) {
      item.checkMark = ''
      this.checkItem = deepCopy(item)
      if(item.contentStatus==1&&item.reviewStatus==1) {
         this.checkItem.reviewStatus = ''
         this.checkItem.status = ''
         this.checkItem["checkMark"] = ''
         this.checkItem.catalogs = []
      }else {
        this.checkItem.catalogs = item.catalogs.split(',')
        this.checkItem.catalogName = item.catalogName.split(',')
        // this.checkItem.schemaData = this.formatSchemaData(this.checkItem.schemaData)
        console.log('this.checkItem',this.checkItem)
      }
      this.showCheck = true
    },
    // 打开日志
    openLog: debounce(function (item) {
      getApproveLogs({
        bizCode: 40,
        bizRefrenceId: item.id
      }).then(res => {
        if (res.data.code === 200) {
          this.logData = res.data.data
          this.showLog = true
        } else {
          this.$message.error(res.data.msg)
        }
      })
    }, 300, false),
    // 打开编辑
    openEdit (item) {
      console.log("[openEdit]",item)
      this.showEdit = true
      this.showProgress = false
      this.authProgress = 0
      if (item.id) {
        if(item.schemaData && item.schemaData.length>=1){
          console.log(typeof(item.schemaData[0].appId))
          let arr = item.schemaData.slice(0)
          console.log(typeof(arr[0].appId))
          arr.shift() 
          this.form.dynamicItem =deepCopy(arr)
          console.log(this.form.dynamicItem)
          this.form.androidSchema = item.schemaData[0].androidSchema || ''
          this.form.iosSchema = item.schemaData[0].iosSchema || ''
          this.form.appId = item.schemaData[0].appId|| ''
          console.log(typeof(this.form.appId))
        } else {
          this.form.dynamicItem = []
          this.form.androidSchema = ''
          this.form.iosSchema =  ''
          this.form.appId =  ''
        }
        this.checkItem = deepCopy(item)
        this.checkItem.catalogs = this.checkItem.catalogs.split(',')
        let list = item.playInfo
        let urls = list.filter(item => (item.format == 'mp4' || item.format == 'MP4') )
        let flist = [{"name":urls[0].playURL}]
        this.fileList = flist
        //封面图
        this.fileImgesList = [{name:"",url: this.checkItem.coverImageUrl}]
        //分组标签
        this.selectValue = this.checkItem.groupName
      }else {
        this.checkItem = {}
        return false
      }
    },
    // 获取视频分类
    getclassified () {
      let postData = {
        fullName: '',
        videoCatalogName: ''
      }
      let onSuccess = res => {
        this.listLoading = false
        this.catalogList = this.formateList(res.data.data)
        console.log("this.catalogList--------", this.catalogList)
      }
      getclassifiedList(postData).then(onSuccess).catch(() => { this.listLoading = false })
    },
    // 获取列表
    getList () {
      this.endUpdateTime = moment( moment( this.endUpdateTime).toDate()).format('YYYY-MM-DD 23:59:59')
      this.startUpdateTime =  moment( moment( this.startUpdateTime).toDate()).format('YYYY-MM-DD 00:00:00')
      this.listLoading = true
      let postData = {
        id: this.formId,
        status: this.formStatus,
        name: this.formName,
        startUpdateTime: this.startUpdateTime,
        endUpdateTime: this.endUpdateTime,
        reviewStatus: this.activeName === '0'?this.formCheckStatus:'',
        current: this.pageNo,
        size: this.pageSize,
        groupName: this.selectValue,
        deptId: this.selectedId,
      }
      let onSuccess = res => {
        this.listLoading = false
        if (res.data.code === 200) {
          this.tableData = res.data.data.records
          this.totalEl = res.data.data.total
        } else {
          this.$message.error(res.data.msg)
        }
      }
      // 区分线上本地列表接口
      if (this.activeName === '0') {
        this.requestUrlType = 'local'
      }else {
        this.requestUrlType = 'online'
      }
      contentList(postData, this.requestUrlType).then(onSuccess).catch(() => { this.listLoading = false })
    },
    // 删除
    delDiscount (item) {
      this.$confirm('确定要删除选中的数据吗？', '提示', {
        type: 'warning'
      }).then(() => {
        removeVideo(item.id).then(res => {
          if (res.data.code === 200) {
            this.getList()
          } else {
            this.$message.error(res.data.msg)
          }
        })
      })
    },
    // 提交编辑
    submitEdit: debounce(function (item) {
      console.log("this.form.dynamicItem",this.form.dynamicItem )


      console.log('submit addid' , this.form.appId)
      if (this.form.appId==''){
         this.checkItem.schemaData = []
      } else {
        this.checkItem.schemaData = []
        let obj = { 
          androidSchema:this.form.androidSchema,
          appId:this.form.appId,
          iosSchema:this.form.iosSchema
        }
        this.checkItem.schemaData.push(obj)
      }
      if (this.form.dynamicItem !='') {
        let flag = this.form.appId
        let result = this.form.dynamicItem.find(x => x.appId == flag)
        let valueArr = this.form.dynamicItem.map(function(item){ return item.appId });
        let isDuplicate = valueArr.some(function(item, idx){ 
          return valueArr.indexOf(item) != idx 
        })
        console.log('resule', result)
        if (result!==undefined||isDuplicate==true){
          this.$message.error('不能添加多个相同的跳转应用，保存失败')
          return false
        }
      }
      this.checkItem.schemaData = this.checkItem.schemaData.concat(this.form.dynamicItem)
      this.checkItem.groupName = this.selectValue.toString()
      this.checkItem.catalogs = item.catalogs.toString()
      console.log('提交数据----',this.checkItem)
      submitEditData(this.checkItem).then(res => {
        if (res.data.code === 200) {
          console.log(res)
          this.showEdit=false
          this.getList()
        } else {
          this.$message.error(res.data.msg)
        }
      })
    }, 300, false),
    // 提交审核
    submitcheck: debounce(function (item, status){
      let postData = {
        bizRefrenceId: item.id,
        status: status
      }
      submitExamine(postData).then(res => {
        if (res.data.code === 200) {
          console.log(res)
          this.showCheck = false
          this.getList()
        } else {
          this.$message.error(res.data.msg)
        }
      })
      console.log(postData)
    },300,false),

    // 提交审批
    changeCheck: debounce(function (item) {
      if (item.catalogs.length == 0) {
        this.$message.warning('请为此视频选择分类')
        return
      }
      if (item.reviewStatus === '') {
        this.$message.warning('请选择审批意见')
        return
      }
      let postData = {}
      if (item.reviewStatus == 3) { //审核拒绝
        postData = {
          bizRefrenceId: item.id,
          status: item.reviewStatus,
          content: item.checkMark,
          data:{
            catalogs: item.catalogs.toString(),
          }
        }
        if (!item.checkMark && item.reviewStatus === 3) {
          this.$message.warning('请输入拒绝理由')
          return
        }
      } else {
        postData = {
          bizRefrenceId: item.id,
          status: item.reviewStatus,
          data:{
            catalogs: item.catalogs.toString(),
            status: item.status
          }
        }
        if (item.status === '') {
        this.$message.warning('请选择展示状态')
        return
      }
      }
      console.log("postData------",postData)
      submitExamine(postData).then(res => {
        if (res.data.code === 200) {
          console.log(res)
          this.showCheck = false
          this.getList()
        } else {
          this.$message.error(res.data.msg)
        }
      })
    }, 300, false),
      //上传视频
      handleChangeVideo(file,fileList) {
        console.log('[handleChangeVideo] ',file.raw.type)
        const isJPG = file.raw.type === 'video/mp4';
        const isLt1G = file.raw.size / 1024 / 1024 / 1024 < 1;
        this.fileList = fileList.slice(1); //永远只保持一个文件
        console.log("[handleChangeVideo]", this.fileList)
        if (!isJPG) {
          this.$message.error('上传的视频只能是 .mp4 格式!');
       
          return false;
        }
        if (!isLt1G) {
          this.$message.error('上传的视频大小不能超过 1G!');
          return false;
        }
        
        let flist = [];
        flist.push({"name":file.raw.name})
        this.fileList  = flist
        this.files.videoFile = file.raw
        console.log('[handleChangeVideo]', this.files.videoFile)
        this.uploader = this.createUploader()
        console.log('this.uploader ', this.uploader)
        let userData = '{"Vod":{}}'
        this.uploader.addFile( this.files.videoFile, null, null, null, userData)
        this.uploader.startUpload()
      },
      //上传图片
      handleChangeImgs(file,fileList) {
        if(file.raw.size > (500*1024) ){
          if( this.fileImgesList.length ==0 ){
                this.fileImgesList = []
          }else{
             this.fileImgesList = [fileList[0]]
          }
          this.$message.error('上传的封面图片大小不能超过 500KB !');
          return 
        }
        this.fileImgesList = [fileList[fileList.length - 1]]
        const formData = new FormData()
        formData.append('file', file.raw)
        console.log(file.raw)
        putFile(formData).then( res => {
          if (res.data.code === 200) {
            this.checkItem.coverImageUrl = res.data.data.link
            this.$forceUpdate()
            console.log(res.data.data.link) 
            console.log('this.checkItem.coverImageUrl',this.checkItem.coverImageUrl)
          } else {
            this.$message.error(res.data.msg)
          }
        })

      },
      handleRemove (){
        this.checkItem.coverImageUrl = ''
      },
      // 导出
      handleExport () {
        let postData = {
          id: this.formId,
          status: this.formStatus,
          name: this.formName,
          startUpdateTime: this.startUpdateTime,
          endUpdateTime: this.endUpdateTime,
          reviewStatus: this.activeName === '0'?this.formCheckStatus:'',
          current: this.pageNo,
          size: this.pageSize,
          groupName: this.selectValue,
          deptId: this.selectedId,
          isUsed: this.activeName
        }

        downloadFile('/lebo-vod/video/export-record', postData);
      },
      createUploader () {
        let self = this
        // eslint-disable-next-line no-undef
        let uploader = new AliyunUpload.Vod({
          timeout: self.timeout || 60000,
          partSize: self.partSize || 1048576,
          parallel: self.parallel || 5,
          retryCount: self.retryCount || 3,
          retryDuration: self.retryDuration || 2,
          region: 'cn-shanghai',
          userId: '210518107822932423',
          // 添加文件成功
          addFileSuccess: function (uploadInfo) {
            self.uploadDisabled = false
            self.resumeDisabled = false
            self.statusText = '添加文件成功, 等待上传...'
            console.log("addFileSuccess: " + uploadInfo.file.name)
          },
          // 开始上传
          onUploadstarted: function (uploadInfo) {
            console.log('[onUploadstarted] ',uploadInfo)
            // 如果是 UploadAuth 上传方式, 需要调用 uploader.setUploadAuthAndAddress 方法
            // 如果是 UploadAuth 上传方式, 需要根据 uploadInfo.videoId是否有值，调用点播的不同接口获取uploadauth和uploadAddress
            // 如果 uploadInfo.videoId 有值，调用刷新视频上传凭证接口，否则调用创建视频上传凭证接口
            // 注意: 这里是测试 demo 所以直接调用了获取 UploadAuth 的测试接口, 用户在使用时需要判断 uploadInfo.videoId 存在与否从而调用 openApi
            // 如果 uploadInfo.videoId 存在, 调用 刷新视频上传凭证接口(https://help.aliyun.com/document_detail/55408.html)
            // 如果 uploadInfo.videoId 不存在,调用 获取视频上传地址和凭证接口(https://help.aliyun.com/document_detail/55407.html)
            if (!uploadInfo.videoId) {
              // let createUrl = 'http://saas.test.hpplay.com.cn/api/lebo-vod/video/getUploadVideo'
              // axios.get(createUrl).then(({data}) => {
              //   let uploadAuth = data.UploadAuth
              //   let uploadAddress = data.UploadAddress
              //   let videoId = data.VideoId
              //   uploader.setUploadAuthAndAddress(uploadInfo, uploadAuth, uploadAddress,videoId)                
              // })

              getUploadVideo('测试').then( resultData => {
                console.log('获取视频上传地址和凭证 ',resultData.data.data)
                let data = resultData.data.data;
                let uploadAuth = data.uploadAuth
                let uploadAddress = data.uploadAddress
                let videoId = data.videoId
                console.log(uploadAuth )
                console.log(uploadAddress )
                console.log(videoId)
                // self.checkItem.vid = videoId
                console.log('self.checkItem.vid',self.checkItem.vid)
                uploader.setUploadAuthAndAddress(uploadInfo, uploadAuth, uploadAddress,videoId)                
              })
              console.log('文件开始上传...')
              console.log("onUploadStarted:" + uploadInfo.file.name + ", endpoint:" + uploadInfo.endpoint + ", bucket:" + uploadInfo.bucket + ", object:" + uploadInfo.object)
            } else {
              // 如果videoId有值，根据videoId刷新上传凭证
              // https://help.aliyun.com/document_detail/55408.html?spm=a2c4g.11186623.6.630.BoYYcY
            //  let refreshUrl = 'https://demo-vod.cn-shanghai.aliyuncs.com/voddemo/RefreshUploadVideo?BusinessType=vodai&TerminalType=pc&DeviceModel=iPhone9,2&UUID=59ECA-4193-4695-94DD-7E1247288&AppVersion=1.0.0&Title=haha1&FileName=xxx.mp4&VideoId=' + uploadInfo.videoId
              getUploadVideo('测试').then( resultData => {
                console.log('获取视频上传地址和凭证 ',resultData.data.data)
                let data = resultData.data;
                let uploadAuth = data.uploadAuth
                let uploadAddress = data.uploadAddress
                let videoId = data.videoId
                self.checkItem.vid = videoId
                console.log('self.checkItem.vid',self.checkItem.vid)
                uploader.setUploadAuthAndAddress(uploadInfo, uploadAuth, uploadAddress,videoId)                
              })
            }
          },
          // 文件上传成功
          onUploadSucceed: function (uploadInfo) {
            console.log("onUploadSucceed: " + uploadInfo.file.name + ", endpoint:" + uploadInfo.endpoint + ", bucket:" + uploadInfo.bucket + ", object:" + uploadInfo.object)
            self.checkItem.vid = uploadInfo.videoId
            self.$forceUpdate()
            self.statusText = '文件上传成功!'
            console.log( self.statusText )
          },
          // 文件上传失败
          onUploadFailed: function (uploadInfo, code, message) {
            console.log("onUploadFailed: file:" + uploadInfo.file.name + ",code:" + code + ", message:" + message)
            self.statusText = '文件上传失败!'
            console.log( self.statusText )
          },
          // 取消文件上传
          onUploadCanceled: function (uploadInfo, code, message) {
            console.log("Canceled file: " + uploadInfo.file.name + ", code: " + code + ", message:" + message)
            self.statusText = '文件已暂停上传'
            console.log( self.statusText )
          },
          // 文件上传进度，单位：字节, 可以在这个函数中拿到上传进度并显示在页面上
          onUploadProgress: function (uploadInfo, totalSize, progress) {
            self.showProgress = true
            console.log("onUploadProgress:file:" + uploadInfo.file.name + ", fileSize:" + totalSize + ", percent:" + Math.ceil(progress * 100) + "%")
            let progressPercent = Math.ceil(progress * 100)
            self.authProgress = progressPercent
            self.statusText = '文件上传中...'
            console.log( self.statusText )
          },
          // 上传凭证超时
          onUploadTokenExpired: function (uploadInfo) {
            // 上传大文件超时, 如果是上传方式一即根据 UploadAuth 上传时
            // 需要根据 uploadInfo.videoId 调用刷新视频上传凭证接口(https://help.aliyun.com/document_detail/55408.html)重新获取 UploadAuth
            // 然后调用 resumeUploadWithAuth 方法, 这里是测试接口, 所以我直接获取了 UploadAuth
            let refreshUrl = 'https://demo-vod.cn-shanghai.aliyuncs.com/voddemo/RefreshUploadVideo?BusinessType=vodai&TerminalType=pc&DeviceModel=iPhone9,2&UUID=59ECA-4193-4695-94DD-7E1247288&AppVersion=1.0.0&Title=haha1&FileName=xxx.mp4&VideoId=' + uploadInfo.videoId
            axios.get(refreshUrl).then(({data}) => {
              let uploadAuth = data.UploadAuth
              uploader.resumeUploadWithAuth(uploadAuth)
              console.log('upload expired and resume upload with uploadauth ' + uploadAuth)
            })
            self.statusText = '文件超时...'
            console.log( self.statusText )
          },
          // 全部文件上传结束
          onUploadEnd: function (uploadInfo) {
            console.log("onUploadEnd: uploaded all the files",  uploadInfo)
            self.statusText = '文件上传完毕'
            console.log( self.statusText )
          }
        })
        return uploader
      },

  }
}
</script>

<style lang="scss">
  .el-image {
    width: 120px;
    height: 70px;
  }
  .viewbigImg {
    position: relative;
    top: -8px;
    left: 20px;
  }
  .checkitemcheck {
    margin-left: -110px !important;
  }
</style>
